export default __webpack_public_path__ + "static/media/erp-2.a3c06d64.png";